import axios from 'axios';

const instance = axios.create({
    credentials: 'include',
    baseURL: process.env.REACT_APP_BASE_URL+"/api/zibazi/organ-manager/",
    timeout: 120000
});

export default instance;